import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService } from './app.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
   providedIn: 'root',
})
export class MsWordService {
   constructor(private httpClient: HttpClient, private app: AppService) {}
   officeUrl = 'ms-word:ofe|u|';

   prepareTemplateDocument(body: any) {
      let headers = new HttpHeaders();
      return this.httpClient.post(this.app.getDocManagerUrl() + environment.documentPrepareTemplate, body, { responseType: 'text' }) as Observable<any>;
   }

   openWordTemplateDocumentForCase(body: any, loggedIn: any, subjectId: string, isAssurance: boolean = false): Observable<string> {
      return this.prepareTemplateDocument(body).pipe(
         tap(documentName => {
            const encodedName = encodeURIComponent(documentName);
            const url =
               this.officeUrl +
               this.app.getDocManagerUrl() +
               environment.webdavTemplateUrl +
               loggedIn.id +
               '/' +
               loggedIn.csrId +
               '/' +
               subjectId +
               '/' +
               body.caseId +
               (isAssurance ? '/1' : '/0') +
               '/' +
               body.documentId +
               '/' +
               encodedName;
            window.location.href = url;
         })
      );
   }

   openWordTemplateDocumentForCaseWithType(body: any, loggedIn: any, subjectId: string, doctype: any) {
      this.prepareTemplateDocument(body).subscribe(documentName => {
         const encodedName = encodeURIComponent(documentName);
         const url =
            this.officeUrl +
            this.app.getDocManagerUrl() +
            environment.webdavTemplateWithTypeUrl +
            doctype +
            '/' +
            loggedIn.id +
            '/' +
            loggedIn.csrId +
            '/' +
            subjectId +
            '/' +
            body.caseId +
            '/' +
            body.documentId +
            '/' +
            encodedName;
         window.location.href = url;
      });
   }

   openWordDocumentForSubject(body: any, loggedIn: any, subjectId: string) {
      const encodedName = encodeURIComponent(body.fileName);
      const url = this.officeUrl + this.app.getDocManagerUrl() + environment.webdavUrlSubject + loggedIn.id + '/' + loggedIn.csrId + '/' + subjectId + '/' + body.documentId + '/' + encodedName;
      window.location.href = url;
   }

   openWordDocumentForCase(body: any, loggedIn: any, subjectId: string) {
      const encodedName = encodeURIComponent(body.fileName);
      const url =
         this.officeUrl + this.app.getDocManagerUrl() + environment.webdavUrl + loggedIn.id + '/' + loggedIn.csrId + '/' + subjectId + '/' + body.caseId + '/' + body.documentId + '/' + encodedName;
      window.location.href = url;
   }

   openWordDocumentForEvaluation(body: any, loggedIn: any, workerId: string, isNewDocument: any) {
      const encodedName = encodeURIComponent(body.fileName);
      const url = this.officeUrl + this.app.getDocManagerUrl() + environment.webdavUrlEvaluation + isNewDocument + '/' + loggedIn.id + '/' + workerId + '/' + body.documentId + '/' + encodedName;
      window.location.href = url;
   }
}
